export async function apiAction({ url, method = 'get', data = null, token = null }) {
    // console.log(url)
    let options = {
        method: method,
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": "token " + token
        }
    }
    if (method.toLowerCase() === "get") {
        delete options["body"]
    }
    try {
        let response = await fetch(url, options)
        if (!response.ok) {
            console.error(`API Error: ${response.status} - ${url}`);
            return null;
        }
        
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            return await response.json();
        } else {
            return null;
        }
    } catch (error) {
        console.log('api_Action :', error)
        if (url.includes("health")) {
            return { "success": false }
        }
    }
}

/* ─────────────────────────────────────────
   apiPost — structured { data, error } variant for POST requests.
   Use this instead of apiAction for any call-site that needs to
   distinguish between an empty result and a real error.
   Legacy callers of apiAction are left untouched.
───────────────────────────────────────── */
export async function apiPost({ url, data = null, token = null }) {
    const options = {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": "token " + token,
        },
    };
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            console.error(`apiPost Error: ${response.status} - ${url}`);
            return { data: null, error: { status: response.status, message: getErrorMessage(response.status) } };
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
            return { data: await response.json(), error: null };
        }
        return { data: null, error: null };
    } catch (err) {
        console.error('apiPost network error:', err);
        return { data: null, error: { status: 0, message: getErrorMessage(0) } };
    }
}

/* ─────────────────────────────────────────
   apiFetch — structured { data, error } variant
   Used by useFetch hook for error-aware components.
   Keeps apiAction untouched for existing callers.
───────────────────────────────────────── */
function getErrorMessage(status) {
    if (status === 0) return 'Unable to load data. Check your internet connection and try again.';
    if (status >= 500) return 'Something went wrong. Please try again.';
    return 'Could not load this section. Please try again.';
}

export async function apiFetch({ url, method = 'get', data = null, token = null }) {
    const options = {
        method,
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": "token " + token
        }
    };
    if (method.toLowerCase() === "get") {
        delete options.body;
    }
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            console.error(`apiFetch Error: ${response.status} - ${url}`);
            return { data: null, error: { status: response.status, message: getErrorMessage(response.status) } };
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
            return { data: await response.json(), error: null };
        }
        return { data: null, error: null };
    } catch (err) {
        console.error('apiFetch network error:', err);
        return { data: null, error: { status: 0, message: getErrorMessage(0) } };
    }
}